import { render, staticRenderFns } from "./contact-list.vue?vue&type=template&id=a225d426&scoped=true&"
import script from "./contact-list.vue?vue&type=script&lang=js&"
export * from "./contact-list.vue?vue&type=script&lang=js&"
import style0 from "./contact-list.vue?vue&type=style&index=0&id=a225d426&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a225d426",
  null
  
)

export default component.exports